import { useEffect, useRef, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import Image from "src/components/elements/Image";
import { isSVGString } from "src/helpers";
import { classNames } from "src/helpers/classNames";
import TopMenuItemLink from "./TopMenuItemLink";

const TopMenuSubItem = ({ data, group_id, page_id, searchTerm, handleClick = () => {} }) => {
  const [imageClassName, setImageClassName] = useState("");
  const [isExpanded, setIsExpanded] = useState(data?.isOpen ? true : false);
  const subItemRef = useRef(null);

  const toggleSubMenu = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (isExpanded && subItemRef.current) {
      subItemRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [isExpanded]);

  const isActive = () => {
    if (!isExpanded) {
      return data._id === group_id || data.slug === group_id || (data.groupId === group_id && data.submenu.some((item) => item.slug === page_id));
    }
  };

  return (
    <div
      className="group/subitem relative"
      ref={subItemRef}>
      <button
        type="button"
        className={classNames(
          "duration-20 flex min-h-10 w-full items-center justify-between space-x-1 rounded px-3 transition-all md:text-base",
          isActive() ? "!bg-leftNavActiveColor !text-leftNavActiveTextColor" : "text-leftNavTextColor hover:!bg-leftNavActiveColor hover:!text-leftNavActiveTextColor",
        )}
        onClick={toggleSubMenu}>
        <div className="flex items-center">
          {data.image && (
            <div className={classNames("nav-icon mr-2 h-5 w-5 flex-shrink-0 flex-grow-0", imageClassName)}>
              {isSVGString(data.image) ? (
                <div dangerouslySetInnerHTML={{ __html: data.image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"') }} />
              ) : (
                <Image
                  src={data.image}
                  alt={"Menu image"}
                  classes={imageClassName}
                  onError={() => setImageClassName("hidden")}
                />
              )}
            </div>
          )}
          <div className="flex flex-shrink flex-grow items-center text-left font-medium">{data.name}</div>
        </div>

        <ChevronDownIcon className={classNames("h-6 w-6 rounded-md stroke-2 p-1", isExpanded ? "rotate-180" : "")} />
      </button>

      {isExpanded && Array.isArray(data.submenu) && data.submenu.length > 0 && (
        <div className={classNames("visible relative ml-1 min-w-36 rounded-md bg-leftNavColor py-2 pl-2 pr-2 transition-all")}>
          <div className="space-y-1">
            {data.submenu.map((subitem) => {
              return (
                <TopMenuItemLink
                  key={subitem.page_slug || subitem._id}
                  data={subitem}
                  image={subitem?.image}
                  group_id={group_id}
                  page_id={page_id}
                  searchTerm={searchTerm}
                  handleClick={handleClick}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default TopMenuSubItem;
